var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('lv-radio-group',{attrs:{"options":_vm.options,"pulse":_vm.pulse,"color":"success","outline":"","value":_vm.modelValue},on:{"input":_vm.updateValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }